import React from 'react'
import PropTypes from "prop-types"

import {
  Modal, Panel, Form, FormGroup, FormControl,
  ControlLabel, InputGroup, Checkbox
} from 'react-bootstrap'

import Button from '../../components/Button.jsx'
import MarkdownField from '../../lib/MarkdownField.jsx'
import FilesSelector from '../../lib/FilesSelector.jsx'
import { getText } from '../../lib/text.js'
import TranslateLink from '../../components/TranslateLink'

const styles = {
  fg: { display: "block", padding: 2 },
  label: { width: 200 },
  sublabel: { color: "#555", marginBottom: 2, fontSize: 14, fontStyle: "italic" },
}

class Drink extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  render() {
    const { drink, onChange, onRemove }  = this.props
    return (
      <Panel style={{ marginBottom: 3, position: 'relative' }}>
        <Panel.Body>
          <div style={{ display: 'inline', width: '100%' }}>
            {
              drink.background && drink.background.image
                ? (
                  <img src={drink.background.image} style={{ height: 40 }} />
                )
                : (
                  <span style={{ fontSize: 24 }}>🍷 {' '}</span>
                )
            }
            <span style={{ marginLeft: 10 }}>
              {drink.name || getText("Sin nombre")}
            </span>
            <Checkbox
              style={{ display: "inline", marginLeft: 40 }}
              checked={drink.isInMenus}
              onChange={evt => onChange({ isInMenus:evt.target.checked })}
            >
              Incluido en menus
            </Checkbox>

            <div style={{ marginLeft: 20, display: "inline" }}>
              <ControlLabel>Orden: {' '}</ControlLabel>
              <FormControl
                style={{ display: "inline", maxWidth: 70, marginLeft: 5 }}
                type="number"
                value={drink.order}
                onChange={evt => onChange({ order: parseInt(evt.target.value || "0") })}
              />
            </div>
            <Button
              onClick={() => this.setState({ open: true })}
              style={{ position: 'absolute', right : 10 }}
              glyph="pencil"
            />
          </div>

          {
            (this.state.open) && (
              <Modal show onHide={() => this.setState({ open: false })}>
                <Modal.Header>
                  <Modal.Title>Bebida:{' '}{drink.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                  <Form inline>
                    <Checkbox
                      checked={drink.isInMenus}
                      onChange={evt => onChange({ isInMenus:evt.target.checked })}
                    >
                      {"  Incluido en menus"}
                    </Checkbox>

                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>🇪🇸 Nombre para nosotros: {' '}</ControlLabel>
                      <FormControl
                        className= "name-control"
                        type="text"
                        value={drink.name}
                        onChange={evt => onChange({ name: evt.target.value })}
                      />
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>
                        🇨🇳 Nombre para cliente:
                      </ControlLabel>
                      <FormControl
                        className= "chname-control"
                        type="text"
                        value={drink.chName}
                        onChange={evt => onChange({ chName: evt.target.value })}
                      />
                      <TranslateLink text={drink.chName} />
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>
                        {getText("Precio")}:
                      </ControlLabel>
                      <InputGroup>
                        <FormControl
                          className= "price-control"
                          type="number"
                          value={drink.price}
                          onChange={evt => onChange({ price: evt.target.value })}
                        />
                        <InputGroup.Addon>€</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>
                        {getText("Orden")}:
                      </ControlLabel>
                      <FormControl
                        className= "chname-control"
                        type="number"
                        value={drink.order}
                        onChange={evt => onChange({ order: parseInt(evt.target.value || "0") })}
                        style={{ maxWidth: 90 }}
                      />
                    </FormGroup>

                    <FormGroup style={styles.fg}>
                      <MarkdownField
                        style={{ marginTop: 10 }}
                        onChange={description => onChange({ description })}
                        value={drink.description}
                        label={(
                          <span>
                            {getText("🇨🇳 Descripción bebida (cortita)")}
                            <TranslateLink text={drink.description} />
                          </span>
                        )}
                      />
                    </FormGroup>
                    <FilesSelector
                      value={drink.background}
                      onChange={background => onChange({ background })}
                      includeNotes
                      fileNotes={drink.fileNotes}
                      onNotesChange={fileNotes => onChange({ fileNotes })}
                      labels={{ image: getText("Imágen") }}
                      extensions={{ image: ["jpg", "jpeg", "png"] }}
                      title = {getText("Imagen bebida")}
                    />
                    <Button
                      glyph="minus"
                      bsStyle="link"
                      onClick={() => onRemove()}
                    >
                Eliminar bebida
                    </Button>
                  </Form>

                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => this.setState({ open: false })}>Cerrar</Button>
                </Modal.Footer>
              </Modal>
            )
          }
        </Panel.Body>
      </Panel>

    )
  }
}

Drink.propTypes = {
  drink: PropTypes.object,
  onChange: PropTypes.func.isRequired, // object => void
  onRemove: PropTypes.func.isRequired, // () => void
}

export default Drink
